import React from 'react';
import Context from './context';
import AppTypography from '../../core/Typography/AppTypography';
import Box from '@material-ui/core/Box';
import OsakiImage from '../../../images/features/jtb/osaki.png';
import { CONTACT } from '../routing';
import { ServiceButton } from '../../core/Button';

const Partner = () => {
  const { classes } = React.useContext(Context);

  return (
    <div className={classes.titleBox}>
      <AppTypography
        className="title"
        color="props.palette.secondary.main"
        size={24}
        weight="bold"
        align="center"
      >
        連携パートナー
      </AppTypography>
      <div style={{ textAlign: 'center' }}>
        <Box
          component="img"
          src={OsakiImage}
          width="100%"
          height="auto"
          maxWidth={140}
        />
      </div>
      <Box
        display="flex"
        alignItems="center"
        mt={5}
        flexDirection={{ xs: 'column', sm: 'row' }}
      >
        <AppTypography
          color="palette.text.primary"
          mb={{ xs: 2, sm: 0 }}
          width="100%"
          lineHeight={1.8}
          maxWidth={450}
        >
          <span>おてつたびでは連携パートナーまだまだ募集中しています！</span>
          <span>お気軽にお問い合わせください！</span>
        </AppTypography>
        <Box
          ml="auto"
          mr={{ xs: 'auto', sm: 0 }}
          pl={{ sm: 4 }}
          textAlign={{ sm: 'right' }}
          width="100%"
        >
          <ServiceButton
            color="primary"
            variant="contained"
            href={CONTACT}
            style={{ maxWidth: 445, whiteSpace: 'normal', textAlign: 'center' }}
            size="large"
          >
            連携を希望される出品事業者の方はこちら
          </ServiceButton>
        </Box>
      </Box>
    </div>
  );
};

export default Partner;
